import React, { useState, useEffect } from "react";
import moment from "moment";
import about from "../../assets/image/about_nha_pg_logo.png";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const ConfirmPatientDetail = ({
  setIsconfirm,
  handleBack,
  setCurrentStep,
  userData,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [confirmdetail, setConfirmDetail] = useState(null);

  useEffect(() => {
    if (userData) {
      window.history.pushState(null, null, null);
      window.addEventListener("popstate", function (event) {
        window.history.pushState(null, null, null);
      });
      setConfirmDetail(userData);
    } else {
      try {
        const storedData = localStorage.getItem("selectedIndex");
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          setConfirmDetail(parsedData);
        }
      } catch (error) {
        console.error("Error parsing confirmdetail from localStorage:", error);
      }
    }
  }, [userData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isChecked) {
      setCurrentStep("SendAdharOTP");
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Confirm Detail Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Confirm Details</h3>
                  <p className="lmop-card-subtitle">
                    Please verify your profile before continuing
                  </p>

                  <form onSubmit={handleSubmit}>

                    {/* Patient detail card */}
                    {confirmdetail ? (
                      <div
                        className="d-flex align-items-center p-3 mb-3 rounded"
                        style={{
                          background: "#f5f6f8",
                          border: "1px solid #e2e5ec",
                          borderRadius: "10px",
                        }}
                      >
                        <div
                          className="me-3 d-flex align-items-center justify-content-center text-white fw-bold"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "#007bff",
                            fontSize: "20px",
                            textTransform: "uppercase",
                            flexShrink: 0,
                          }}
                        >
                          {confirmdetail?.fname?.charAt(0) || confirmdetail?.fullname?.charAt(0)}
                        </div>
                        <div>
                          <h5 className="mb-1 patient-name" style={{ fontSize: "0.95rem", color: "#111" }}>
                            {confirmdetail.fname
                              ? confirmdetail.fname + " " + confirmdetail.lname
                              : confirmdetail.fullname}
                          </h5>
                          <div className="d-flex flex-wrap gap-2 patient-self" style={{ fontSize: "0.82rem", color: "#666" }}>
                            <span>Self |</span>
                            <span>{confirmdetail?.gender} |</span>
                            <span>{confirmdetail?.dob}</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p style={{ color: "#888", fontSize: "0.85rem" }}>No patient selected.</p>
                    )}

                    {/* Checkbox */}
                    <div className="d-flex mt-2 mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input checkbox-color"
                        id="flexCheckDefault"
                        autoComplete="off"
                        checked={isChecked}
                        onChange={() => setIsChecked(!isChecked)}
                      />
                      <label
                        className="form-check-label ps-2"
                        htmlFor="flexCheckDefault"
                        style={{ fontSize: "0.82rem", color: "#555" }}
                      >
                        I agree to{" "}
                        <a
                          href="https://abym.in/term-of-conditions"
                          className="resend-otp"
                          title="Terms of Use"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Terms & Conditions
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://abym.in/privacy-policy"
                          className="resend-otp"
                          title="Privacy Policy"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Privacy Policy
                        </a>{" "}
                        AbyM to Create/Link my ABHA.
                      </label>
                    </div>

                    {/* Back + Continue buttons */}
                    <div className="d-flex gap-3 mt-2">
                      <button
                        type="button"
                        onClick={handleBack}
                        style={{
                          flex: 1,
                          padding: "14px",
                          borderRadius: "999px",
                          border: "1.5px solid #d0d5e0",
                          background: "transparent",
                          color: "#555",
                          fontFamily: "Manrope, sans-serif",
                          fontWeight: "700",
                          fontSize: "0.92rem",
                          cursor: "pointer",
                          transition: "border 0.2s, color 0.2s",
                        }}
                      >
                        Back
                      </button>
                      <button
                        type="submit"
                        className={`lmop-continue-btn ${!isChecked ? "bg-disable" : ""}`}
                        disabled={!isChecked}
                        style={{ flex: 1, marginTop: 0 }}
                      >
                        Continue
                      </button>
                    </div>

                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmPatientDetail;